import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ActionTooltip from './action_tooltip';

// eslint-disable-next-line import/prefer-default-export
export class Action extends PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.state = { showTooltip: false };
  }

  render() {
    const customAttributes = {};
    if (this.props.tagType === 'a') {
      customAttributes.href = this.props.href || '#';
      if (this.props.target) customAttributes.target = this.props.target;
    }

    return (
      <this.props.tagType
        {...customAttributes}
        className={this.styleClass()}
        onClick={this.onClick}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.hideTooltip}
        disabled={this.props.disabled}
      >
        {this.precedingIcon()}
        &nbsp;{this.renderButtonText()}&nbsp;
        {this.trailingIcon()}
        {this.renderTooltip()}
      </this.props.tagType>
    );
  }

  onMouseEnter(e) {
    if (this.props.withFocus) {
      e.target.focus();
    }
    if (this.props.tooltip) {
      this.showTooltip();
    }
  }

  renderTooltip() {
    const tooltip = [];
    if (this.props.tooltip) {
      tooltip.push(
        <ActionTooltip
          key={this.props.name}
          tooltip={this.props.tooltip}
          showTooltip={this.state.showTooltip}
        />
      );
    }
    return tooltip;
  }

  styleClass() {
    const actionClasses = [this.props.styleClass];
    if (this.props.disabled) actionClasses.push('disabled');
    if (this.props.tooltip) actionClasses.push('popup');
    return actionClasses.join(' ').trim();
  }

  renderButtonText() {
    return !this.props.iconOnly ? (
      <span className="action-name">{this.props.name}</span>
    ) : null;
  }

  showTooltip() {
    this.setState({ showTooltip: true });
  }

  hideTooltip() {
    if (this.props.tooltip) this.setState({ showTooltip: false });
  }

  precedingIcon() {
    return this.props.precedingIcon ? this.iconContent() : null;
  }

  trailingIcon() {
    return !this.props.precedingIcon ? this.iconContent() : null;
  }

  // TODO Send the icon font type with the icon as a prop
  fontType() {
    const fontType = String(this.props.styleClass);
    if (fontType.includes('fa-regular')) {
      return 'regular';
    }
    if (fontType.includes('fa-light')) {
      return 'light';
    }
    if (fontType.includes('fa-thin')) {
      return 'thin';
    }
    if (fontType.includes('fa-duotone')) {
      return 'duotone';
    }
    if (fontType.includes('fa-solid')) {
      return 'solid';
    }
    return 'solid';
  }

  iconContent() {
    let iconContent = null;
    let icon = null;

    if (this.props.icon) icon = this.props.icon;
    if (this.props.loading) icon = 'fa-circle-notch fa-spin';

    if (icon) iconContent = <i className={`fa-${this.fontType()} ${icon}`} />;

    return iconContent;
  }

  onClick(event) {
    if (this.props.disabled) {
      event.preventDefault();
      return;
    }

    if (this.props.href && this.props.tagType === 'a' && !this.props.callbackFunction) {
      return;
    }
    event.preventDefault();
    if (this.props.disabled) {
      return;
    }
    if (this.props.callbackFunction) {
      this.props.callbackFunction();
    }
  }
}

Action.contextTypes = {
  store: PropTypes.object
};

Action.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.string,
  callbackFunction: PropTypes.func,
  tagType: PropTypes.any,
  href: PropTypes.any,
  target: PropTypes.any,
  tooltip: PropTypes.any,
  withFocus: PropTypes.any,
  link: PropTypes.any,
  type: PropTypes.any,
  disabled: PropTypes.any,
  confirm: PropTypes.any,
  entity: PropTypes.any,
  icon: PropTypes.any,
  loading: PropTypes.any,
  precedingIcon: PropTypes.any,
  styleClass: PropTypes.any,
  iconOnly: PropTypes.any
};

Action.defaultProps = {
  name: '',
  loading: false,
  tagType: 'button',
  styleClass: 'btn',
  precedingIcon: true,
  withFocus: false
};
